import { useEffect, useState, useLayoutEffect } from 'react';
import { appConfig } from '../../config';
import { themes } from '../../themes/themes.js';

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
}

export const useIsLessThanTablet = () => {
  const windowSize = useWindowSize();
  const [isLess, setIsLess] = useState(false);
  useEffect(() => {
    if (windowSize.width < 1024 && !isLess) {
      setIsLess(true);
    } else if (windowSize.width >= 1024 && isLess) {
      setIsLess(false);
    }
  }, [isLess, windowSize.width]);
  return isLess;
};

export const useIsLessThan = (widthThreshold) => {
  const windowSize = useWindowSize();
  const [isLess, setIsLess] = useState(false);
  useEffect(() => {
    if (windowSize.width < widthThreshold && !isLess) {
      setIsLess(true);
    } else if (windowSize.width >= widthThreshold && isLess) {
      setIsLess(false);
    }
  }, [isLess, widthThreshold, windowSize.width]);
  return isLess;
};

export const useIsLessThanHeight = (heightThreshold) => {
  const windowSize = useWindowSize();
  const [isLess, setIsLess] = useState(false);
  useEffect(() => {
    if (windowSize.height < heightThreshold && !isLess) {
      setIsLess(true);
    } else if (windowSize.height >= heightThreshold && isLess) {
      setIsLess(false);
    }
  }, [heightThreshold, isLess, windowSize.height]);
  return isLess;
};

export const getThemeByPartner = () => {
  const configTheme = appConfig.whiteLabelPartner;

  switch (configTheme) {
    case 'disona':
      return themes.disonaTheme;
    default:
      return themes.defaultTheme;
  }
};

export const useMountTransition = (isMounted, delay) => {
  const [hasTransitionedIn, setHasTransitionedIn] = useState(false);

  useLayoutEffect(() => {
    let timeoutId;
    if (isMounted && !hasTransitionedIn) {
      timeoutId = setTimeout(() => setHasTransitionedIn(true), delay);
    } else if (!isMounted && hasTransitionedIn) {
      timeoutId = setTimeout(() => setHasTransitionedIn(false), delay);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [delay, isMounted, hasTransitionedIn]);

  return hasTransitionedIn;
};

export const IS_DISONA = appConfig.whiteLabelPartner === 'disona';
export const IS_ROCKWEST = appConfig.whiteLabelPartner === 'rock-west';

export const placeholder = (cssString) => `
  ::-webkit-input-placeholder { /* WebKit browsers */
    ${cssString}
  }
  :-moz-placeholder { /uppercase* Mozilla Firefox 4 to 18 */
   ${cssString}
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    ${cssString}
  }
  :-ms-input-placeholder { /* Internet Explorer 10+ */
     ${cssString}
  }
  ::placeholder { /* Recent browsers */
     ${cssString}
  }
`;
